//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createSlice } from "@reduxjs/toolkit";



//-------------------------------------------------------------------------------------------------- Interfaces
export interface CountInterface {
    count: number;
};



//-------------------------------------------------------------------------------------------------- Vars and consts
const countSliceInitialState = {
    count: 0
} as CountInterface;



//-------------------------------------------------------------------------------------------------- Slice
const countSlice = createSlice({
    name: "count",
    initialState: countSliceInitialState,
    reducers: {
        setCount: (state, action: PayloadAction<CountInterface>) => {
            state.count = action.payload.count;
        },
        clearCount: (state) => {
            state.count = countSliceInitialState.count;
        }
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export const {setCount, clearCount} = countSlice.actions;
export const getCount = (state: any) => state.count;
export default countSlice.reducer;
